<template>
  <div class="commonAgreement-container">
    <div>
      <div>
        <div class="agreement-h1">“2025规范人人行”</div>
        <div class="agreement-h1">项目劳务协议书</div>
        <CommonHeader :doctorInfo="doctorInfo"></CommonHeader>
        <!-- <div style="margin: 10px 0">
          尊敬的
          <span class="agreement-underline-span">{{
            doctorInfo.name || "xxx"
          }}</span
          >：
        </div> -->
        <div class="agreement-abstract">
          于
          <span class="agreement-underline-span">
            “{{ doctorInfo.meet_start_time?.split("-")[0] }}年
            {{ doctorInfo.meet_start_time?.split("-")[1] }}月
            {{
              doctorInfo.meet_start_time?.split("-")[2].substr(0, 2)
            }}日”</span
          >
          >开展的
          <span class="agreement-underline-span">“2025规范人人行”</span
          >项目，乙方为甲方在执行期间提供
          <span class="agreement-underline-span">讲者</span>
          劳务服务。为明确双方义务及权利，依据《中华人民共和国民法典》等其他相关法律法规之规定，双方在平等自愿基础之上达成以下一致协议：
        </div>

        <div class="agreement-h3">第一条 合同期限</div>
        <p class="agreement-content-row">
          自本协议签署之日起至本项目结束之日止。
        </p>
        <div class="agreement-h3">第二条 乙方提供的劳务内容</div>
        <p class="agreement-content-row">
          疾病领域宣讲、培训、咨询服务、内容特许使用权等与项目教育相关的内容。
        </p>
      </div>
      <div>
        <div class="agreement-h3">第三条 劳务费用支付及方式</div>
        <p class="agreement-content-row">
          本合同采用按次结算，每次劳务费税后¥<span
            class="agreement-underline-div"
            >{{ doctorInfo.money }}</span
          >元整，支付方式经双方协商结算。
          <!-- （大写人民币：
          <span class="agreement-underline-div">{{
            this.$tools.intToChineseMo(doctorInfo.money)
          }}</span
          >，作为您提供专业服务的报酬，您同意基金会代您向国家税务部门缴纳该笔劳务所得报酬的税费。各方同意，该报酬对于您在本协议项下履行的工作而言是合理且适当的。上海馨心医学科技发展基金会将在您完成约定服务后
          60日内通过银行汇款形式完成付款。 -->
        </p>
      </div>
      <div class="agreement-underline-div">
        账户名称：<span>{{ doctorInfo.name }}</span>
      </div>
      <div class="agreement-underline-div">
        身份证号码：<span>{{ doctorInfo.id_card_number }}</span>
      </div>
      <div class="agreement-underline-div">
        开户行：<span>{{ doctorInfo.bank_name_point }}</span>
      </div>
      <div class="agreement-underline-div">
        银行卡号：<span>{{ doctorInfo.bank_number }}</span>
      </div>
      <div class="agreement-underline-div">
        手机号：<span>{{ doctorInfo.phone }}</span>
      </div>

      <div>
        <div class="agreement-h3">第四条 双方的基本权利与义务</div>
        <p class="agreement-content-row">
          1、如乙方严重违反合同约定及法律规定，甲方有权终止协议。
        </p>
        <p class="agreement-content-row">
          2、乙方由于个人原因所发生的疾病以及伤残等意外事故，乙方自行负责。
        </p>
        <p class="agreement-content-row">
          3、任何一方单方面解除本协议的，需以书面通知另一方，经双方协商终止本协议。
        </p>
        <p class="agreement-content-row">
          4、双方应严格保守在合作过程中所了解的商业及技术机密，否则应对因此造成的损失承担赔偿。
        </p>
        <p class="agreement-content-row">
          5、本协议解除或终止时，乙方应向甲方指定的人员交接工作；并立即停止以甲方名义从事一切活动；交接清晰一些与工作相关的事务。
        </p>
        <p class="agreement-content-row">
          6、乙方应按照甲方要求提供劳务服务，不得弄虚作假。
        </p>
        <p class="agreement-content-row">
          7、乙方保证具有完成劳务服务的专业知识与经验，不得提供虚假履历与身份信息。
        </p>
        <p class="agreement-content-row">
          8、乙方在本项目宣讲过程中所载有肖像的视频、音频、录像及照片等资料，乙方同意甲方在全球范围内免费使用，同意甲方用于学习及科学研究。
        </p>
        <p class="agreement-content-row">
          9、甲方依法为乙方代扣代缴个人所得税，乙方应当如实按照我国税法相关规定进行居民个人综合所得年度汇算申报。
        </p>
      </div>

      <div>
        <div class="agreement-h3">第五条本协议解除终止情形：</div>
        <p class="agreement-content-row">1、双方就解除本协议协商一致的；</p>
        <p class="agreement-content-row">
          2、乙方专业能力无法完成合同约定内容的。
        </p>
        <p class="agreement-content-row">
          3、因不可抗力或其他原因致使本协议无法继续履行的。
        </p>
      </div>
      <div>
        <div class="agreement-h3">第六条 其他</div>
        <p class="agreement-content-row">
          1、本协议如有未尽事宜，双方另行签订补充协议，补充协议与本协议具有同等法律效力。
        </p>
        <p class="agreement-content-row">
          2、双方因本协议发生争议首先应友好协商解决，协商不成的，均可向甲方所在地人民法院诉讼解决。
        </p>
        <p class="agreement-content-row">
          3、协议一式两份，甲、乙双方各执一份，经甲方盖章,乙方签字之日起生效。
        </p>
      </div>
    </div>
    <div class="agreement_sign_info">
      <div class="agreement_sign_them">
        <div class="agreement_sign_name">
          <span> 甲方： </span>{{ doctorInfo.agreement_company_name }}
        </div>
        <div class="agreement-sign-date">
          日期：{{
            $tools.getDate(doctorInfo.meet_start_time, "yyyy年MM月dd日")
          }}
        </div>
      </div>
      <div class="agreement_sign_them">
        <div class="agreement_sign_name">
          <span ref="signData_one">乙方（签字）：</span>
          <img
            :src="signInfo.data[0]"
            @click="doSignName(0)"
            v-if="signInfo.data[0]"
            alt=""
          />
          <CustomButton
            class="agreement-sign-button"
            size="small"
            @click="doSignName(0)"
            v-else-if="!signInfo.data[0] && isCanSign"
          >
            <div>
              <span>签名</span>
            </div>
          </CustomButton>
        </div>
        <div class="agreement_sign_date">
          日期：{{
            $tools.getDate(doctorInfo.meet_start_time, "yyyy年MM月dd日")
          }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomButton from "@/components/unit/CustomButton";
import { CircleCheck } from "@element-plus/icons";
import "../../../../assets/icon/iconfont.css";
import CommonHeader from "../header/commonHeader";
export default {
  name: "common-info",
  props: {
    signInfo: {
      type: Object,
      default: {},
    },
    doctorInfo: {
      type: Object,
      default: {},
    },
    isCanSign: {
      type: Boolean,
      default: false,
    },
    meetInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      data: {},
    };
  },
  components: {
    CustomButton,
    CommonHeader,
    CircleCheck,
  },
  methods: {
    verifyData() {
      if (!this.signInfo.data[0]) {
        console.log(this.$refs.signDataOne);
        let height = this.$refs.signDataOne.offsetTop;
        this.$emit("doScroll", height);
        this.$tips.error({ text: "请签署协议后再提交" });
        // this.$tips.error({ text: "请先签署第一个签名" });
        return false;
      }
      // if (!this.signInfo.data[1]) {
      //   let height = this.$refs.signDataTwo.offsetTop;
      //   this.$emit("doScroll", height);
      //   this.$tips.error({ text: "请先签署第二个签名" });
      //   return false;
      // }
      return true;
    },
    doSignName(index) {
      if (!this.isCanSign) return;
      this.$emit("doSignName", index);
    },
  },
};
</script>
<style>
.agreement-sign-button {
  width: 64px !important;
  font-size: 13px;
}
.agreement-td:last-child {
  border-right: 0;
}
.agreement-row:last-child > .agreement-td {
  border-bottom: 0;
}
.agreement-h1-second {
  margin-top: 30px;
}
.agreement_sign_info {
  display: flex;
}
.agreement_sign_them {
  flex: 1 0 0;
  margin-right: 0.25rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.agreement_sign_info > div {
  flex: 1 0 0;
}
.agreement_sign_name {
  /* height: 2.5rem; */
  flex: 1 0 0;
  display: flex;
  align-items: center;
}
.agreement_sign_name span {
  white-space: nowrap;
}
.agreement_sign_name img {
  width: 3rem;
  height: auto;
}
</style>